import useAgentData from '~/client/hooks/useAgentData';
import useIsBottomNavigation from '~/client/hooks/useIsBottomNavigation';
import DepositButtonBottomMenu from './DepositButtonBottomMenu';
import DepositButtonDesktop from './DepositButtonDesktop';
import DepositButtonMobile from './DepositButtonMobile';

type Props = { text: string; cashierPath?: string };

const DepositButton: FC<Props> = ({ text, cashierPath }) => {
  const isBottomNavigation = useIsBottomNavigation();
  const { isDesktop } = useAgentData();
  if (isDesktop) {
    return <DepositButtonDesktop text={text} cashierPath={cashierPath} />;
  }
  if (isBottomNavigation) {
    return <DepositButtonBottomMenu text={text} />;
  }
  return <DepositButtonMobile text={text} />;
};

export default DepositButton;
